import { combineReducers } from 'redux';

import { HtmlEntities } from '@utils';

import { dmca, getDmcaInitialState } from './DmcaReducer';
import { subscriptions, getSubscriptionsInitialState } from './SubscriptionsReducer';

import { IState } from '@interfaces';

export const rootReducer = combineReducers({
	dmca,
	subscriptions,
});

let initialState: IState;

try {
	initialState = JSON.parse(HtmlEntities.decode(document.getElementById('initial-state').innerHTML));
} catch (err) {
	initialState = {} as IState;
}

export const getInitialState = (): IState => ({
	...initialState,
	dmca: getDmcaInitialState(),
	subscriptions: getSubscriptionsInitialState(),
});
